import ProducsDataCreatina from "../Products/Creatina";
import ProducsDataHypercaloric from "../Products/Hypercaloric";
import ProducsDataPreworkout from "../Products/Preworkout";
import ProducsDataTermogenico from "../Products/Termogenico";
import ProducsDataWhey from "../Products/Whey";

const ProducsDataAll = [
  ...ProducsDataCreatina,
  ...ProducsDataHypercaloric,
  ...ProducsDataPreworkout,
  ...ProducsDataTermogenico,
  ...ProducsDataWhey,
];

export default ProducsDataAll;
